<template>
  <b-row align-v="center">
    <b-col cols="12" sm="6">
      <span class="text-muted">
        <template v-if="total > 0">
          Showing {{ from }} to {{ to }} of
        </template>
        {{ total }} entries
      </span>
    </b-col>

    <!-- Pagination -->
    <b-col class="tw-flex tw-items-end tw-justify-end" cols="12" sm="6">
      <b-pagination-nav
        v-if="pageTotal > 1"
        v-model="currentPageLocal"
        :number-of-pages="pageTotal"
        :link-gen="linkGen"
        use-router
        @change="onPageChange"
      />
    </b-col>
  </b-row>
</template>

<script>
import { defineComponent, ref, computed, watch } from "@vue/composition-api";
import { BRow, BCol, BPaginationNav } from "bootstrap-vue";

export default defineComponent({
  components: {
    BRow,
    BCol,
    BPaginationNav,
  },
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  emits: ["update:currentPage"],
  setup(props, { emit }) {
    const currentPageLocal = ref(props.currentPage);

    watch(
      () => props.currentPage,
      (newVal) => {
        currentPageLocal.value = newVal;
      }
    );

    const onPageChange = (page) => {
      emit("update:currentPage", page);
    };

    const from = computed(() => {
      if (props.total === 0) return 0;
      return (currentPageLocal.value - 1) * props.pageSize + 1;
    });

    const to = computed(() => {
      return Math.min(currentPageLocal.value * props.pageSize, props.total);
    });

    const pageTotal = computed(() => {
      return Math.ceil(props.total / props.pageSize);
    });

    const linkGen = (pageNum) => {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    };

    return {
      currentPageLocal,
      from,
      to,
      pageTotal,
      linkGen,
      onPageChange,
    };
  },
});
</script>

<style>
.b-pagination {
  margin-bottom: 0 !important;
}
</style>
